/* b2s-steps-title-to-span.js — convert h3 titles in steps-curve to span */
(function(){
  'use strict';

  function convertTitles() {
    const sections = document.querySelectorAll('section.steps-curve, .steps-curve');
    sections.forEach(sec => {
      const headings = sec.querySelectorAll('.curve-content h1, .curve-content h2, .curve-content h3, .curve-content h4, .curve-content h5, .curve-content h6');
      headings.forEach(h => {
        if (h.dataset.b2sConverted) return;
        const span = document.createElement('span');
        span.className = 'b2s-step-title';
        span.textContent = h.textContent;
        for (const attr of h.attributes) {
          if (attr.name !== 'class') span.setAttribute(attr.name, attr.value);
        }
        span.dataset.b2sConverted = '1';
        h.parentNode.replaceChild(span, h);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', convertTitles);
  } else {
    convertTitles();
  }
  const obs = new MutationObserver(() => convertTitles());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
